module.exports = __webpack_public_path__ + "static/img/hero-cv-4.2e90eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/pc/imgs/hero-cv-4.png
// module id = xn1A
// module chunks = 13